import {useTheme} from '@primer/styled-react'
import {clsx} from 'clsx'

import {getProviderFor, type Provider} from './config'
import styles from './ProviderLogo.module.css'

// Mimics https://github.com/primer/octicons/blob/2ddd06c415447f85d35e24285fb4f2682a8f21e4/lib/octicons_react/src/index.d.ts#L7
type Size = 'small' | 'medium' | 'large'

export function ProviderLogo({
  className,
  provider: providerKey,
  size = 'small',
}: {
  className?: string
  provider: Provider
  size?: Size
}) {
  const provider = getProviderFor(providerKey)

  const colorMode = useTheme().colorMode
  // ColorMode can be: 'dark' | 'night' or 'light' | 'day' or 'auto'. Lets take that to 'light', 'dark', or 'auto'
  const normalizedColorMode = colorMode === 'night' ? 'dark' : colorMode === 'day' ? 'light' : 'auto'
  const hasDarkModeImage = !!provider.logo.dark

  return (
    <picture className={clsx(styles.ProviderLogo, className)} data-size={size}>
      {hasDarkModeImage && normalizedColorMode === 'dark' && <source srcSet={provider.logo.dark} />}
      {hasDarkModeImage && normalizedColorMode === 'auto' && (
        <source srcSet={provider.logo.dark} media="(prefers-color-scheme: dark)" />
      )}
      <img src={provider.logo.light} alt={`${provider.name} logo`} aria-hidden />
    </picture>
  )
}

try{ ProviderLogo.displayName ||= 'ProviderLogo' } catch {}